import React from "react";
import "../style.css";

const Process: React.FC = () => {
    return (
        <div id="processes" className="processesPage" style={{
            backgroundColor: "white"
        }}>

            <div className="process-grid-container" style={{
                display: "grid",
            }}> 
            
            <div className="processHeader"style= {{}}>  
                    <div style= {{
                        zIndex: "0",
                        position:"absolute",
                        width: "100%",
                        height: "350px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage: "url('/images/gallery/TapewormDisassembled.jpg')",
                    }}></div>

                    <div className="processHeaderDescription" style= {{
                        }}>
                        <h6 style= {{
                            fontSize: "20px",
                            paddingBottom: "0rem",
                        }}>Processes Tab</h6>
                        <h3 style= {{
                            fontFamily: "ConsolaMono",
                            fontSize: "40px",
                            textAlign: "left",
                        }}>Meet Our</h3> 
                        <h3 style= {{
                            fontFamily: "ConsolaMono",
                            fontSize: "40px",
                            textAlign: "left",
                            color: "#4952f8",
                        }}>Sub-Teams </h3>
                    </div>

                    <p className="goalDescription" style={{}}>
                        Our Goal: At SURF we are trying our best to make a 
                        working and reliable underwater autonomus vehicle </p>

                    <div className="process-grid-box" style={{}}>
                        <ElectricalProcess/>
                        <SoftwareProcess/>
                        <MechanicalProcess />
                    </div>
                </div>
            </div>
            
        </div>
    );
};


const ElectricalProcess = () => {
    return (
        <div className="Electrical_Process" style={{}}>
            <div className="Flexbox_Container" style={{}}>
                
                <div className="Electrical_Description">
                    <h3 style={{}}>Electrical Team</h3>
                    <hr/>
                    <p>This year the surf electrical team is working on a complete redesign of the sub's electronics.
                        We are creating several new PCB boards. The different boards all serve different functions.
                        First, we are designing the circuits in an Electronic Design Automation software(EDA).
                        We simulate the circuit in a spice simulator. Second, we go through the circuit and start selecting part and Integrated circuits(ICs).
                        This can be the most time intensive part of the process. We pour over datasheet, comparing requirements,
                        and changing our designs to make it more practical and efficient. Finally, we built a 3D model of the circuit board.
                        This part requires a lot of planning and revision. A lot of factors go into a good design. All of these tasks are not 
                        taught in the Electrical engineering program and require us to research and learn on our own.</p>
                </div>
                <div className="Electrical_Content" style={{}}>
                    <img src="/images/gallery/ElectricalContent1.jpg" alt="ElectricalContent1" style={{
                        // maxWidth: "200px",
                        // height: "auto",
                        // marginLeft: "40px",
                        // marginRight: "40px"
                        // height: "300px",
                    }} />
                </div>
            </div>
        </div>
    )
}
const SoftwareProcess = () => {
    return (
        <div className="Software_Process" style={{}}>
            <div className="Flexbox_Container" style={{
                display: "flex",
                flexDirection: "row",
            }}>
                <div className="Software_Description">
                    <h3 style={{}}>Software Team</h3>
                    <hr/>
                    <p>The software team's main responsibility is making the sub able to navigate an underwater obstacle course autonomously. We seek to accomplish this task by using a combination of sensor data and machine learning. We use machine learning to help us find objects and choose what the agenda is dynamically based on the bot's proximity to tasks. The software team also works closely with both the mechanical and electrical team members to design and integrate new parts and systems into the sub. These additions then allow the bot to tackle new tasks such as manipulating shells with a grasper of some kind. </p>
                </div>

                {/* <img src="/images/gallery/SURF2025_StateMachine-Main_State_Machine.drawio_1.png" alt="SoftwareContent1" style={{
                            // maxWidth: "575px", //TODO PLEASE REPLACE THIS IMAGE PRONTO
                            // height: "auto",
                            // maxHeight: "400px",
                            // marginLeft: "40px",
                            // marginRight: "40px"
                            // height: "300px",
                        }} /> */}
            </div>
        </div>
    )
}

const MechanicalProcess = () => {
    return (
        <div className="Mechanical_Process" style={{}}>
            <div className="Flexbox_Container" style={{
                display: "flex",
                flexDirection: "row",
            }}>

            <div className="Mechanical_Description">
                <h3 style={{}}>Mechanical Team</h3>
                <hr/>

                <p>Our team is involved in ensuring the submarine meets all necessary buoyancy and mechanical specifications. 
                    We use spreadsheets to perform buoyancy calculations, which help us determine the ideal material choices and designs for different components. 
                    To comply with competition specifications, we must ensure that our robot and all components that detach from it during competition are buoyant 
                    by at least 0.5% by weight. One of the most crucial aspects of our work is collaborating with the electrical team to determine size requirements 
                    for our electronics enclosures, ensuring that all components fit securely and wires can be routed between boards and our bulkhead connectors. 
                    We design our electronics enclosures with tight tolerances to ensure that they will be waterproof. Additionally, the mechanical team produces the items necessary for testing the 
                    capabilities of our robot, including building structures out of PVC pipe to imitate the competition tasks. </p> 
                    {/* update this text, it is basically ripped off of the welome meet page*/}
                    </div>
                {/* <img src="/images/gallery/TapewormModelVertical.png" alt="MechanicalContent1" style={{
                        maxWidth: "200px",
                        height: "300px",
                        marginLeft: "40px",
                        marginRight: "40px"
                        // height: "300px",
                    }} /> */}
            </div>

        </div>
    )
}

export default Process;
